import React, { Fragment } from "react";

import { Route, Switch } from "react-router-dom";

import { Box, Flex, PageContainer } from "src/components";
import { stripTrailingSlash } from "src/utils";

import Enroll, { EnrollComplete } from "./Enroll";
import Login from "./Login";
import {
  ForgotLoginEntryForm,
  ForgotUsernameForm,
} from "./ForgotFlow/ForgotLogin";

import ForgotChallengeQuestions from "./ForgotFlow/ForgotChallengeQuestions";

const Authentication = ({ match, baseUrl = stripTrailingSlash(match.url) }) => (
  <PageContainer
    key="content"
    themeName="green"
    roundTopCorners={true}
    p={[3, 3, 3, 4]}
  >
    <Route
      exact
      path={baseUrl}
      render={({ ...routeProps }) => (
        <Login
          onComplete={() => {
            if (routeProps.location.pathname === "/app") {
              window.location.reload();
            } else {
              routeProps.history.push("/app");
            }
          }}
          {...routeProps}
        />
      )}
    />
    <Route path={`${baseUrl}/enrolled`} component={EnrollComplete} />
    <Route path={`${baseUrl}/enroll`} component={Enroll} />
    <Route
      path={`${baseUrl}/forgotPassword`}
      component={ForgotLoginEntryForm}
    />
    <Route path={`${baseUrl}/forgotUsername`} component={ForgotUsernameForm} />
    <Route
      path={`${baseUrl}/forgotChallengeQuestions`}
      component={ForgotChallengeQuestions}
    />
  </PageContainer>
);

export default Authentication;



// WEBPACK FOOTER //
// ./src/banking/authentication/Authentication.js